export default "__VITE_ASSET__CxDBWLPb__"